<template>
  <div class="ranking-list">
    <div v-if="title" class="ranking-header">
      <div class="ranking-header-left">
        <div class="ranking-accent" :style="{ backgroundColor: accentColor }"></div>
        <h3 class="ranking-title">{{ title }}</h3>
      </div>
      <div class="ranking-header-right">
        <span class="ranking-subtitle">BY LOADS</span>
      </div>
    </div>
    <div v-if="title" class="ranking-divider"></div>
    <div class="ranking-content">
      <div v-if="loading" class="ranking-loading">
        <div class="loading-spinner"></div>
        <span>Loading...</span>
      </div>

      <div v-else-if="!hasData" class="ranking-empty">
        <span>No data available</span>
      </div>

      <div v-else class="ranking-items">
        <div
          v-for="(item, index) in processedData"
          :key="item.name"
          class="ranking-item"
        >
          <div class="ranking-left">
            <div class="ranking-index">{{ index + 1 }}</div>
            <div class="ranking-name" v-tooltip.top="item.name || ''">{{ item.name }}</div>
          </div>
          <div class="ranking-right">
            <div class="ranking-bar-container">
              <div class="ranking-bar-track"></div>
              <div
                class="ranking-bar-fill"
                :style="{
                  width: `${item.percentage}%`,
                  backgroundColor: '#000033'
                }"
              ></div>
            </div>
            <div class="ranking-value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { processRankingData } from '@/utils/rankingUtils';
import Tooltip from 'primevue/tooltip';

export default {
  name: "RankingList",
  directives: {
    tooltip: Tooltip
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    accentColor: {
      type: String,
      default: "#E65100",
    },
  },
  computed: {
    hasData() {
      return this.data && this.data.length > 0;
    },
    processedData() {
      return processRankingData(this.data, 5);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_dashboard-mixins' as *;

.ranking-list {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ranking-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0 8px 0;
}

.ranking-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ranking-accent {
  @include dashboard-accent;
}

.ranking-title {
  @include dashboard-title;
}

.ranking-header-right {
  display: flex;
  align-items: center;
}

.ranking-subtitle {
  font-size: 12px;
  color: #999999;
  font-weight: 500;
  text-transform: uppercase;
}

.ranking-divider {
  @include dashboard-divider;
}

.ranking-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.ranking-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 8px;
  color: #666;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #000033;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.ranking-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: #999;
}

.ranking-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ranking-item {
  @include ranking-item-layout;
}

.ranking-left {
  @include ranking-left-column;
}

.ranking-index {
  @include ranking-index;
}

.ranking-name {
  @include ranking-name;
}

.ranking-right {
  @include ranking-right-column;
}

.ranking-bar-container {
  @include ranking-bar-container;
}

.ranking-bar-track {
  @include ranking-bar-track;
}

.ranking-bar-fill {
  @include ranking-bar-fill;
}

.ranking-value {
  @include ranking-value;
}
</style>
